<template>
  <UserShell
    :title="pageTitle"
    subtitle="填写主播真实信息，*标记为必填项"
    :profile="profile"
    :menu-items="menuItems"
    active-key="talent"
    center-path="/user/org"
  >
    <div class="back-row">
      <button type="button" class="back-btn" @click="$router.back()">&lt; 上一页</button>
    </div>

    <div class="form-wrap">
      <div class="field-block"><div class="field-label">主播姓名 <span class="required">*</span></div><el-input v-model.trim="form.name" :disabled="isSubmitting || isUploading" placeholder="请输入真实名称" class="field-control" /></div>
      <div class="field-block"><div class="field-label">手机号 <span class="required">*</span></div><el-input v-model.trim="form.mobile" :disabled="isSubmitting || isUploading" placeholder="请输入手机号" class="field-control" /></div>
      <div class="field-block"><div class="field-label">身份证号 <span class="required">*</span></div><el-input v-model.trim="form.idNo" :disabled="isSubmitting || isUploading" placeholder="请输入身份证号码" class="field-control" /></div>
      <div class="field-block"><div class="field-label">全网粉丝总数 <span class="required">*</span></div><el-input v-model.trim="form.totalFans" :disabled="isSubmitting || isUploading" placeholder="请输入" class="field-control" /></div>
      <div class="field-block"><div class="field-label">全网作品点击量 <span class="required">*</span></div><el-input v-model.trim="form.totalViews" :disabled="isSubmitting || isUploading" placeholder="请输入" class="field-control" /></div>
      <div class="field-block"><div class="field-label">近一年利润 <span class="required">*</span></div><el-input v-model.trim="form.annualProfit" :disabled="isSubmitting || isUploading" placeholder="请输入" class="field-control" /></div>
      <div class="field-block"><div class="field-label">近一年直播场次 <span class="required">*</span></div><el-input v-model.trim="form.liveSessions" :disabled="isSubmitting || isUploading" placeholder="请输入，如无写无" class="field-control" /></div>
      <div class="field-block"><div class="field-label">授权截止日期 <span class="required">*</span></div><el-date-picker v-model="form.expiryDate" :disabled="isSubmitting || isUploading" type="date" value-format="yyyy-MM-dd" placeholder="请选择授权截止日期" class="field-control" /></div>

      <div class="field-block wide-block">
        <div class="field-label">身份证上传 <span class="required">*</span></div>
        <div class="upload-row">
          <button type="button" class="upload-card" :disabled="identityFieldsLocked || isSubmitting || isUploading" @click="triggerUpload('idFront')">
            <img :src="idFrontPreview" alt="身份证正面" referrerpolicy="no-referrer" />
          </button>
          <button type="button" class="upload-card" :disabled="identityFieldsLocked || isSubmitting || isUploading" @click="triggerUpload('idBack')">
            <img :src="idBackPreview" alt="身份证背面" referrerpolicy="no-referrer" />
          </button>
        </div>
        <div class="upload-tip">请提供信息清晰可见的证件照片，支持jpg、png、jpeg 格式的图片，大小不能大于5M</div>
        <input ref="idFront" type="file" class="hidden-input" accept=".jpg,.jpeg,.png" @change="handleFileChange($event, 'idFrontUrl', 'idFrontName')" />
        <input ref="idBack" type="file" class="hidden-input" accept=".jpg,.jpeg,.png" @change="handleFileChange($event, 'idBackUrl', 'idBackName')" />
      </div>

      <div class="field-block wide-block account-section">
        <div class="account-title-row">
          <div class="field-label no-margin">平台账号信息 <span class="required">*</span> <span class="minor-tip">（至少填写一个平台）</span></div>
          <button type="button" class="add-account-btn" :disabled="isSubmitting || isUploading" @click="addAccount">增加平台账号</button>
        </div>

        <div v-for="(account, index) in form.accounts" :key="account.id" class="account-panel">
          <div class="account-grid">
            <div class="field-block small-block"><div class="field-label">平台名称 <span class="required">*</span></div><el-select v-model="account.platform" :disabled="isSubmitting || isUploading" placeholder="请选择平台" class="field-control"><el-option v-for="option in platformOptions" :key="option.value" :label="option.label" :value="option.value" /></el-select></div>
            <div class="field-block small-block"><div class="field-label">垂类赛道 <span class="required">*</span></div><el-select v-model="account.category" :disabled="isSubmitting || isUploading" placeholder="请选择" class="field-control"><el-option v-for="option in categoryOptions" :key="option.value" :label="option.label" :value="option.value" /></el-select></div>
            <div class="field-block small-block"><div class="field-label">平台ID <span class="required">*</span></div><el-input v-model.trim="account.platformId" :disabled="isSubmitting || isUploading" placeholder="请输入" class="field-control" /></div>
            <div class="field-block small-block"><div class="field-label">粉丝数量 <span class="required">*</span></div><el-input v-model.trim="account.fans" :disabled="isSubmitting || isUploading" placeholder="请输入粉丝数量(如:126万)" class="field-control" /></div>
            <div class="field-block small-block"><div class="field-label">主播昵称 <span class="required">*</span></div><el-input v-model.trim="account.nickname" :disabled="isSubmitting || isUploading" placeholder="请输入" class="field-control" /></div>
          </div>
          <button v-if="form.accounts.length > 1" type="button" class="remove-account-btn" :disabled="isSubmitting || isUploading" @click="removeAccount(index)">删除账号</button>
        </div>
      </div>
    </div>

    <div class="footer-actions">
      <button type="button" class="footer-btn ghost" @click="$router.back()">取消</button>
      <button type="button" class="footer-btn primary" :disabled="isSubmitting || isUploading" @click="saveTalent">{{ submitButtonText }}</button>
    </div>
  </UserShell>
</template>

<script>
import UserShell from './components/UserShell.vue';
import sidebarBg from '@/assets/img/user/背景卡图.png';
import userAvatar from '@/assets/img/user/avatar.png';
import overviewActiveIcon from '@/assets/img/user/griconxz.png';
import overviewActiveIconIn from '@/assets/img/user/gricon.png';
import talentActiveIcon from '@/assets/img/user/zbglxz.png';
import talentInactiveIcon from '@/assets/img/user/zbgl.png';
import assetActiveIcon from '@/assets/img/user/申请icon.png';
import assetInactiveIcon from '@/assets/img/user/申请未选中.png';
import defaultIdFrontImage from '@/assets/img/user/身份证正面.png';
import defaultIdBackImage from '@/assets/img/user/身份证背面.png';
import {
  createStreamerProfile,
  getMemberProfile,
  getStreamerProfileDetail,
  updateStreamerProfile,
  uploadMemberImage
} from '@/api/user';

const MAX_IMAGE_SIZE = 5 * 1024 * 1024;
const platformOptions = [
  { value: 'douyin', label: '抖音' },
  { value: 'kuaishou', label: '快手' },
  { value: 'bilibili', label: 'B站' },
  { value: 'xiaohongshu', label: '小红书' },
  { value: 'weibo', label: '微博' },
  { value: 'wechat_video', label: '微信视频号' }
];
const categoryOptions = [
  { value: 'beauty_care', label: '美妆护肤' },
  { value: 'fashion_apparel', label: '服饰穿搭' },
  { value: 'food_beverage', label: '食品饮料' },
  { value: 'digital', label: '3C数码' },
  { value: 'home_living', label: '家居生活' },
  { value: 'maternity_child', label: '母婴育儿' },
  { value: 'education', label: '教育知识' },
  { value: 'sports_outdoors', label: '运动户外' },
  { value: 'gaming', label: '游戏电竞' }
];

function createMenu() {
  return [
    { key: 'overview', label: '首页概览', path: '/user/org', activeIcon: overviewActiveIcon,inactiveIcon: overviewActiveIconIn},
    { key: 'talent', label: '主播管理', path: '/user/org/talents', activeIcon: talentActiveIcon, inactiveIcon: talentInactiveIcon },
    { key: 'asset', label: '资产评估申请', path: '/user/org/assets', activeIcon: assetActiveIcon, inactiveIcon: assetInactiveIcon }
  ];
}

function createAccount() {
  return {
    id: `${Date.now()}-${Math.random()}`,
    platform: '',
    category: '',
    platformId: '',
    fans: '',
    nickname: ''
  };
}

function createEmptyTalent() {
  return {
    id: '',
    name: '',
    mobile: '',
    idNo: '',
    totalFans: '',
    totalViews: '',
    annualProfit: '',
    liveSessions: '',
    expiryDate: '',
    idFrontUrl: '',
    idBackUrl: '',
    idFrontName: '',
    idBackName: '',
    accounts: [createAccount()]
  };
}

function extractResponseData(response) {
  if (!response || typeof response !== 'object') {
    return {};
  }

  if (response.data && typeof response.data === 'object' && !Array.isArray(response.data)) {
    return response.data;
  }

  return response;
}

function extractUploadUrl(response) {
  const data = response && typeof response === 'object' && Object.prototype.hasOwnProperty.call(response, 'data')
    ? response.data
    : response;

  if (typeof data === 'string') {
    return data;
  }

  if (!data || typeof data !== 'object') {
    return '';
  }

  return data.url || data.full_url || data.path || data.location || '';
}

function getFileName(url, fallback) {
  if (!url) {
    return fallback || '';
  }

  const source = String(url).split('?')[0];
  const parts = source.split('/').filter(Boolean);
  return decodeURIComponent(parts[parts.length - 1] || fallback || '');
}

function normalizeAccount(item, index) {
  const source = item && typeof item === 'object' ? item : {};

  return {
    id: source.id || `account-${index}`,
    platform: source.platform || '',
    category: source.vertical_track || source.category || '',
    platformId: source.platform_id || '',
    fans: source.fans_count || '',
    nickname: source.nickname || ''
  };
}

export default {
  name: 'OrganizationTalentForm',
  components: { UserShell },
  computed: {
    isEditMode() {
      return Boolean(this.$route.query.id);
    },
    pageTitle() {
      return this.isEditMode ? '编辑主播' : '增加主播';
    },
    submitButtonText() {
      if (this.isSubmitting) {
        return this.isEditMode ? '保存中...' : '创建中...';
      }
      if (this.isUploading) {
        return '上传中...';
      }
      return this.isEditMode ? '保存主播信息' : '创建主播信息';
    },
    identityFieldsLocked() {
      return this.isEditMode;
    },
    idFrontPreview() {
      return this.form.idFrontUrl || defaultIdFrontImage;
    },
    idBackPreview() {
      return this.form.idBackUrl || defaultIdBackImage;
    }
  },
  data() {
    return {
      platformOptions,
      categoryOptions,
      profile: {
        name: '星辰传媒有限公司',
        role: 'MCN机构',
        avatar: userAvatar,
        background: sidebarBg
      },
      menuItems: createMenu(),
      form: createEmptyTalent(),
      isSubmitting: false,
      isUploading: false
    };
  },
  created() {
    this.fetchProfile();
    this.initPage();
  },
  methods: {
    async fetchProfile() {
      try {
        const profileResponse = await getMemberProfile();
        const profileData = extractResponseData(profileResponse);
        this.profile = {
          ...this.profile,
          name: profileData.name || this.profile.name,
          role: profileData.type_text || this.profile.role,
          avatar: profileData.avatar || this.profile.avatar
        };
      } catch (error) {
        void error;
      }
    },
    async initPage() {
      const currentId = this.$route.query.id;
      if (!currentId) {
        this.form = createEmptyTalent();
        return;
      }

      try {
        const detailResponse = await getStreamerProfileDetail(currentId);
        const detail = extractResponseData(detailResponse);
        const platformAccounts = Array.isArray(detail.platform_accounts)
          ? detail.platform_accounts
          : (Array.isArray(detail.platforms) ? detail.platforms : []);

        this.form = {
          ...createEmptyTalent(),
          id: detail.id || currentId,
          name: detail.name || '',
          mobile: detail.phone || '',
          idNo: detail.id_card_no || '',
          totalFans: detail.total_fans || '',
          totalViews: detail.total_clicks || '',
          annualProfit: detail.last_year_profit || '',
          liveSessions: detail.last_year_live_sessions || '',
          expiryDate: detail.authorization_deadline || '',
          idFrontUrl: detail.id_card_front || '',
          idBackUrl: detail.id_card_back || '',
          idFrontName: getFileName(detail.id_card_front, '身份证正面'),
          idBackName: getFileName(detail.id_card_back, '身份证背面'),
          accounts: platformAccounts.length
            ? platformAccounts.map((item, index) => normalizeAccount(item, index))
            : [createAccount()]
        };
      } catch (error) {
        this.$message.error(error && error.message ? error.message : '获取主播详情失败');
        this.$router.push('/user/org/talents');
      }
    },
    triggerUpload(refName) {
      const target = this.$refs[refName];
      if (target) {
        target.click();
      }
    },
    async handleFileChange(event, urlKey, nameKey) {
      const file = event.target.files && event.target.files[0];
      if (!file) {
        return;
      }

      if (file.size > MAX_IMAGE_SIZE) {
        this.$message.warning('图片大小不能超过5M');
        event.target.value = '';
        return;
      }

      this.isUploading = true;
      try {
        const uploadResponse = await uploadMemberImage(file);
        const uploadUrl = extractUploadUrl(uploadResponse);
        if (!uploadUrl) {
          throw new Error('上传成功但未获取到图片地址');
        }

        this.form[urlKey] = uploadUrl;
        this.form[nameKey] = file.name;
        this.$message.success('图片上传成功');
      } catch (error) {
        this.$message.error(error && error.message ? error.message : '图片上传失败');
      } finally {
        this.isUploading = false;
        event.target.value = '';
      }
    },
    addAccount() {
      this.form.accounts.push(createAccount());
    },
    removeAccount(index) {
      this.form.accounts.splice(index, 1);
    },
    validateForm() {
      const requiredTop = [
        ['name', '请输入主播姓名'],
        ['mobile', '请输入手机号'],
        ['idNo', '请输入身份证号'],
        ['totalFans', '请输入全网粉丝总数'],
        ['totalViews', '请输入全网作品点击量'],
        ['annualProfit', '请输入近一年利润'],
        ['liveSessions', '请输入近一年直播场次'],
        ['expiryDate', '请选择授权截止日期'],
        ['idFrontUrl', '请上传身份证人像面'],
        ['idBackUrl', '请上传身份证国徽面']
      ];
      for (let index = 0; index < requiredTop.length; index += 1) {
        const [field, message] = requiredTop[index];
        if (!this.form[field]) {
          this.$message.warning(message);
          return false;
        }
      }
      if (!/^1\d{10}$/.test(this.form.mobile)) {
        this.$message.warning('请输入正确的手机号');
        return false;
      }
      if (!/(^\d{15}$)|(^\d{17}[\dXx]$)/.test(this.form.idNo)) {
        this.$message.warning('请输入正确的身份证号码');
        return false;
      }
      for (let index = 0; index < this.form.accounts.length; index += 1) {
        const item = this.form.accounts[index];
        if (!item.platform || !item.category || !item.platformId || !item.fans || !item.nickname) {
          this.$message.warning(`请完整填写第${index + 1}个平台账号信息`);
          return false;
        }
      }
      return true;
    },
    buildPlatformPayload(account) {
      return {
        platform: account.platform,
        vertical_track: account.category,
        platform_id: account.platformId,
        fans_count: account.fans,
        nickname: account.nickname
      };
    },
    buildCreatePayload() {
      return {
        name: this.form.name,
        phone: this.form.mobile,
        id_card_no: this.form.idNo,
        total_fans: this.form.totalFans,
        total_clicks: this.form.totalViews,
        last_year_profit: this.form.annualProfit,
        last_year_live_sessions: this.form.liveSessions,
        authorization_deadline: this.form.expiryDate,
        id_card_front: this.form.idFrontUrl,
        id_card_back: this.form.idBackUrl,
        platforms: this.form.accounts.map(this.buildPlatformPayload)
      };
    },
    buildUpdatePayload() {
      return {
        total_fans: this.form.totalFans,
        total_clicks: this.form.totalViews,
        last_year_profit: this.form.annualProfit,
        last_year_live_sessions: this.form.liveSessions,
        authorization_deadline: this.form.expiryDate,
        platforms: this.form.accounts.map(this.buildPlatformPayload)
      };
    },
    async saveTalent() {
      if (!this.validateForm()) {
        return;
      }

      this.isSubmitting = true;
      try {
        if (this.isEditMode) {
          await updateStreamerProfile(this.form.id, this.buildUpdatePayload());
          this.$message.success('主播信息已更新');
        } else {
          await createStreamerProfile(this.buildCreatePayload());
          this.$message.success('主播信息已创建');
        }
        this.$router.push('/user/org/talents');
      } catch (error) {
        this.$message.error(error && error.message ? error.message : (this.isEditMode ? '更新主播失败' : '创建主播失败'));
      } finally {
        this.isSubmitting = false;
      }
    }
  },
  watch: {
    '$route.fullPath'() {
      this.fetchProfile();
      this.initPage();
    }
  }
};
</script>

<style lang="scss" scoped>
.back-row {
 display: flex;
 justify-content: flex-end;
 margin-top: -52px;
}

.back-btn {
  border: 0;
  background: transparent;
  color: #8b90a6;
  font-size: 16px;
  cursor: pointer;
}

.form-wrap {
  max-width: 520px;
  margin-top: 60px;
}

.field-block {
  margin-top: 22px;
}

.wide-block {
  width: 800px;
}

.small-block {
  margin-top: 0;
}

.field-label {
  margin-bottom: 10px;
  color: #3D3D3D;
  font-size: 16px;
  font-weight: 600;
}

.field-label.no-margin {
  margin-bottom: 0;
}

.minor-tip{
	color: #98a1bb;
	font-size: 12px;
	font-weight: 400;
}
.upload-tip {
 font-family: Source Han Sans, Source Han Sans;
 font-weight: 400;
 font-size: 14px;
 color: #A1A1A1;
 line-height: 22px;
 text-align: left;
 margin-top: 10px;
}

.required {
  color: #ff6a6a;
}

.field-control {
  width: 368px;
}

.field-control ::v-deep .el-input__inner,
.field-control ::v-deep .el-range-input {
  height: 42px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
}

.upload-row {
  display: flex;
  gap: 14px;
}

.upload-card {
 width: 144px;
 height: 112px;
  border:0;
  background: #fff;
  cursor: pointer;
}

.upload-card:disabled,
.add-account-btn:disabled,
.remove-account-btn:disabled,
.footer-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.upload-card img {
  width: 144px;
  height: 112px;
  object-fit: contain;
}

.upload-card span {
  display: block;
  margin-top: 8px;
  color: #939ab3;
  font-size: 12px;
  text-align: center;
}

.hidden-input {
  display: none;
}

.account-section {
  margin-top: 30px;
}

.account-title-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.add-account-btn {
  min-width: 110px;
  height: 34px;
  border: 0;
  border-radius: 8px;
  background: #6f68f3;
  color: #fff;
  font-size: 13px;
  cursor: pointer;
}

.account-panel {
  margin-top: 14px;
  padding: 16px 16px 18px;
  border-radius: 12px;
  background: #f8fafc;
}

.account-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px 24px;
}

.remove-account-btn {
  margin-top: 12px;
  border: 0;
  background: transparent;
  color: #6f68f3;
  font-size: 14px;
  cursor: pointer;
}

.footer-actions {
  display: flex;
  justify-content: center;
  gap: 26px;
  margin-top: 36px;
}

.footer-btn {
  min-width: 110px;
  height: 42px;
  border-radius: 8px;
  cursor: pointer;
}

.footer-btn.ghost {
  width: 86px;
   height: 40px;
   background: #FFFFFF;
   border-radius: 8px 8px 8px 8px;
   border: 1px solid #D6D7D9;
   font-size: 13px;
  color: #606266;
}

.footer-btn.primary {
  border: 0;
  color: #fff;
  width: 114px;
  height: 40px;
  background: #6F68F3;
  border-radius: 8px 8px 8px 8px;
}



@media (max-width: 760px) {
  .field-control,
  .form-wrap {
    width: 100%;
  }

  .upload-row,
  .account-title-row,
  .footer-actions {
    flex-direction: column;
    align-items: flex-start;
  }

  .account-grid {
    grid-template-columns: 1fr;
  }
}
</style>
